import React, { useState } from 'react';
import '../styles/Navbar.css'; // Import the CSS file for styling

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleBookOnline = () => {
    window.location.href = 'tel:+18334936242';
    setIsMenuOpen(false);
  };

  // Smooth scroll function
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    // If targetId is 'home', scroll to top
    if (targetId === 'home') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const navbarHeight = document.querySelector('.navbar')?.offsetHeight || 0;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo / Brand */}
        <div className="navbar-logo">
          <a href="/" onClick={(e) => {
            e.preventDefault();
            setIsMenuOpen(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}>
            <span className="logo-icon">🐜</span>
            <span className="logo-text">PestControl <span className="logo-highlight">Today</span></span>
          </a>
        </div>

        {/* Hamburger icon (visible on mobile) */}
        <div className="menu-icon" onClick={toggleMenu}>
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>

        {/* Navigation links */}
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <a 
              href="#home" 
              className="nav-link" 
              onClick={(e) => handleSmoothScroll(e, 'home')}
            >
              Home
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#services" 
              className="nav-link" 
              onClick={(e) => handleSmoothScroll(e, 'services')}
            >
              Services
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#about" 
              className="nav-link" 
              onClick={(e) => handleSmoothScroll(e, 'about')}
            >
              About
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#why-choose-us" 
              className="nav-link" 
              onClick={(e) => handleSmoothScroll(e, 'why-choose-us')}
            >
              Why Us
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#testimonials" 
              className="nav-link" 
              onClick={(e) => handleSmoothScroll(e, 'testimonials')}
            >
              Testimonials
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#contact" 
              className="nav-link" 
              onClick={(e) => handleSmoothScroll(e, 'contact')}
            >
              Contact
            </a>
          </li>
          <li className="nav-item">
            <button className="nav-link nav-cta" onClick={handleBookOnline}>
              📞 Call Now
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;